import React from "react";
import { Link } from "react-router-dom";
import style from "css/template.module.css";
import Sitemap from "./sitemap";
import { useMediaQuery } from "react-responsive";

/**
 * Version : 1.0
 * 작성일자 : 2025-02-10
 * 작성자 : 강연승
 * 설명 : footer
 */

function Footer() {
  //반응형
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  // const check = useMediaQuery({ query: "(max-width: 1024px)" });

  return (
    <>
      <div className={style.footer}>
        {!isMobile && !isTablet ? <Sitemap /> : <></>}

        <div className={style.company_wrap}>
          <img
            src={`${process.env.REACT_APP_CLIENT_URL}img/common/logo3x.webp`}
            alt="logo"
            style={{ width: "137px", height: "auto" }}
          />
          <div className={style.company_info_area}>
            <div className={style.company_info}>
              <div>
                Add : 경기도 안양시 동안구 시민대로 327번길 11-41, 514호
                (관양동)
              </div>
              {!isMobile && !isTablet ? (
                <div>Tel : 070-7798-1311 | Email : support@riv-tech.co.kr</div>
              ) : (
                <>
                  <div>
                    Tel : 070-7798-1311 | <br />
                    Email : support@riv-tech.co.kr
                  </div>
                </>
              )}
            </div>
            <div className={style.company_policy}>
              <Link className={style.company_policy_item}>Privacy Policy</Link>
              <Link className={style.company_policy_item}>
                Terms of Service
              </Link>
              <Link className={style.company_policy_item}>Cookie Policy</Link>
            </div>
          </div>
        </div>
        <div className={style.copyright}>
          @2024 RivTechnology. All rights reserved.
        </div>
      </div>
    </>
  );
}

export default Footer;
